import { render, staticRenderFns } from "./DeletePresence.vue?vue&type=template&id=1b23154b"
import script from "./DeletePresence.vue?vue&type=script&lang=js"
export * from "./DeletePresence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports